// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.equipararMaquinario.title': 'Equiparar maquinário com o Protheus',
    'shipments.equipararMaquinario.descricao': 'Sugestões pelo operador e pela máquina entre as linhas do maquinário e as ocorrências de campo da frente {{frentes}}. Aceite ou recuse cada uma: só o que você mexer é gravado.',
    'shipments.equipararMaquinario.medicao': 'Medição {{numeros}}',
    'shipments.equipararMaquinario.equiparadaPor': 'Já equiparada à linha de {{quem}}',
    'shipments.equipararMaquinario.semOperador': 'Sem operador',
    'shipments.equipararMaquinario.semMaquina': 'Sem máquina',
    'shipments.equipararMaquinario.selecionar': 'Ocorrência do ERP',
    'shipments.equipararMaquinario.semOcorrencia': 'Sem ocorrência',
    'shipments.equipararMaquinario.buscar': 'Buscar ocorrência…',
    'shipments.equipararMaquinario.semLinhas': 'Nenhuma linha de maquinário nesta frente.',
  },
  en: {
    'shipments.equipararMaquinario.title': 'Match machinery with Protheus',
    'shipments.equipararMaquinario.descricao': 'Suggestions by operator and machine between the machinery rows and the field occurrences of front {{frentes}}. Accept or refuse each one: only what you touch is saved.',
    'shipments.equipararMaquinario.medicao': 'Measurement {{numeros}}',
    'shipments.equipararMaquinario.equiparadaPor': 'Already matched to the row of {{quem}}',
    'shipments.equipararMaquinario.semOperador': 'No operator',
    'shipments.equipararMaquinario.semMaquina': 'No machine',
    'shipments.equipararMaquinario.selecionar': 'ERP occurrence',
    'shipments.equipararMaquinario.semOcorrencia': 'No occurrence',
    'shipments.equipararMaquinario.buscar': 'Search occurrence…',
    'shipments.equipararMaquinario.semLinhas': 'No machinery rows on this front.',
  },
  es: {
    'shipments.equipararMaquinario.title': 'Equiparar maquinaria con Protheus',
    'shipments.equipararMaquinario.descricao': 'Sugerencias por operador y máquina entre las líneas de maquinaria y las ocurrencias de campo del frente {{frentes}}. Acepta o rechaza cada una: solo lo que toques se guarda.',
    'shipments.equipararMaquinario.medicao': 'Medición {{numeros}}',
    'shipments.equipararMaquinario.equiparadaPor': 'Ya equiparada a la línea de {{quem}}',
    'shipments.equipararMaquinario.semOperador': 'Sin operador',
    'shipments.equipararMaquinario.semMaquina': 'Sin máquina',
    'shipments.equipararMaquinario.selecionar': 'Ocurrencia del ERP',
    'shipments.equipararMaquinario.semOcorrencia': 'Sin ocurrencia',
    'shipments.equipararMaquinario.buscar': 'Buscar ocurrencia…',
    'shipments.equipararMaquinario.semLinhas': 'Ninguna línea de maquinaria en este frente.',
  },
}
